import { useAddToBasket } from '@/hooks/useAddToBasket';
import { ProductTileCta } from '@/components/ProductTile/ProductTileCta';
import type { Product } from '@/types';

interface AddToBasketMountData {
    code: string;
    quantity?: number;
    label: string;
    product?: Product;
}

/**
 * Generic add-to-basket mount point for server-rendered blocks.
 * Bridges the component-factory pattern (receives data, calls hooks)
 * with ProductTileCta (receives pre-computed handler/state).
 * Reuses ProductTileCta so the button matches product tiles sitewide —
 * purchase-action-aware colours, shopping cart icon, and Notify Me modal.
 */
export const AddToBasketMount = ({ data }: { data: AddToBasketMountData }) => {
    const { code, quantity = 1, product } = data;
    const { addToBasket, isPending } = useAddToBasket(product, 'highlighted-title-callout');

    if (!code || !product) {
        return null;
    }

    return (
        <ProductTileCta
            handler={() => addToBasket({ code, quantity })}
            isPending={isPending}
            product={product}
        />
    );
};
